import React from "react";
import { Link as RouterLink } from "react-router-dom";
// Components
import ButtonBlock from "../../ui/components/ButtonBlock";
import TextBlock from "../../ui/components/TextBlock";
import { Navigation } from "../../navigation";
import { StyledHeroTypography, StyledSectionLayout } from "./Hero.styles";
// MUI
import { Button, Typography } from "@mui/material";
// Assets
import medley2 from "../../../assets/imagesSlider/Medleyhitting.webp";
// Utils
import useMediaQueries from "../../../utils/helpers/useMediaQueries.utils";

const Hero = () => {
  const { isSm, isLg } = useMediaQueries();
  return (
    <StyledSectionLayout
      customMargin={!isSm ? "1rem 1rem 0rem 1rem !important" : "2rem 2rem 0rem 2rem !important"}
      id="hero"
      aria-label="Hero Section"
      component="section"
      backgroundImage={medley2}
    >
      <Navigation isTransparent={true} />
      <TextBlock
        sx={{ zIndex: 500, textAlign: isLg ? "left" : "center", maxWidth: "1164px", minWidth: { lg: "1164px" } }}
        justifyContent={isLg ? "flex-start" : "center"}
        alignItems={isLg ? "flex-start" : "center"}
      >
        <StyledHeroTypography variant="h1" component="h1" gutterBottom>
          <span style={{ fontSize: "45%", lineHeight: "0.45" }}>Home Of The</span>
          <br />
          Blazers
        </StyledHeroTypography>
        <Typography component="p" variant="p" sx={{ maxWidth: { xs: "600px", lg: "950px" }, paddingInline: { xs: ".5rem", md: "0" } }}>
          Welcome to the official site of the Overland Trailblazers Baseball Team! Find game schedules, events, news, and ways to support our players.
          Start exploring below!
        </Typography>
        <ButtonBlock direction={isSm ? "row" : "column"} spacing={2} justifyContent="center" mt={4} sx={{ paddingInline: { xs: "1rem", md: "0" } }}>
          <Button variant="contained" color="secondary" component={RouterLink} to="/authentication/sign-up" size="large">
            Join Our Community
          </Button>
          <Button variant="outlined" color="secondary" component={RouterLink} to="/boosters/volunteer" size="large">
            Interested in volunteering?
          </Button>
        </ButtonBlock>
      </TextBlock>
    </StyledSectionLayout>
  );
};

export default Hero;
